import { motion } from "framer-motion";
import { BlueprintGrid } from "../../components/BlueprintGrid";
import { fadeUp, viewportOnce, stagger } from "../../lib/motion";
import { SECTORS_INTRO, SECTORS } from "../../lib/sectors";

const SectorsHero = () => (
    <section
        data-testid="sectors-hero-section"
        className="relative overflow-hidden bg-ink pt-[128px] lg:pt-[168px]"
    >
        <BlueprintGrid />
        <div className="relative z-10 mx-auto max-w-[1600px] px-6 pb-20 md:px-10 lg:px-16 lg:pb-28">
            <motion.div variants={fadeUp} initial="hidden" animate="show">
                <p className="flex flex-wrap items-center gap-3 font-mono text-[13px] tracking-[0.3em] text-mist">
                    <span className="h-1.5 w-1.5 bg-accent" />
                    BUILDEASE | BUILDING SECTORS
                </p>
                <h1
                    data-testid="sectors-page-headline"
                    className="mt-8 max-w-5xl font-display text-4xl font-semibold leading-[1.08] text-white md:text-6xl"
                >
                    Intelligence Across the Built Environment
                    <span className="text-accent">.</span>
                </h1>
                <p className="mt-6 max-w-2xl text-[16px] leading-relaxed text-mist">
                    {SECTORS_INTRO.copy}
                </p>
                <div className="mt-10">
                    <span
                        data-testid="sectors-current-focus"
                        className="inline-flex max-w-full flex-wrap items-center gap-3 border border-accent/50 bg-accent/10 px-4 py-2.5"
                    >
                        <span className="h-1.5 w-1.5 animate-pulse bg-accent" />
                        <span className="font-mono text-[13px] tracking-[0.22em] text-white">
                            CURRENT FOCUS
                        </span>
                        <span className="font-mono text-[13px] tracking-[0.22em] text-accent">
                            → RESIDENTIAL CONSTRUCTION
                        </span>
                    </span>
                </div>
            </motion.div>

            <motion.div
                variants={stagger}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                data-testid="sectors-intro-index"
                className="mt-16 grid grid-cols-2 gap-6 border-t border-white/10 pt-8 md:grid-cols-4"
            >
                {SECTORS.map((s) => (
                    <motion.div
                        key={s.id}
                        variants={fadeUp}
                        data-testid={`sectors-index-${s.id}`}
                        className="flex flex-col gap-1.5"
                    >
                        <span className="font-mono text-[13px] tracking-[0.22em] text-cad">
                            {s.n}
                        </span>
                        <span className="font-display text-[15px] font-semibold leading-snug text-white md:text-base">
                            {s.title}
                        </span>
                    </motion.div>
                ))}
            </motion.div>
        </div>
    </section>
);

export default SectorsHero;
